import { Injectable } from '@angular/core';

@Injectable()
export class SidebarService {

    protected openedState: boolean;

    /**
     * Open the sidebar
     */
    public open() {
        this.openedState = true;
    }

    /**
     * Close the sidebar
     */
    public close() {
        this.openedState = false;
    }

    /**
     * Toggle the sidebar's open state
     */
    public toggle() {
        this.openedState = !this.openedState;
    }

    /**
     * Returns whether the sidebar is open or not
     *
     * @returns {boolean}
     */
    public isOpen() {
        return this.openedState;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/services/sidebar.service.ts